import React from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import LanguageSwitch from './LanguageSwitch';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <header className="fixed w-full bg-white/80 backdrop-blur-md z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/MainLogo.webp" alt="Simons Marketing Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold text-black">
              Simons <span className="text-emerald-600">Marketing</span>
            </span>
          </Link>

          <div className="flex items-center space-x-4">
            <LanguageSwitch />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-gray-700 hover:text-blue-600"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
